// client/src/utils/schemeStats.js
// Единая точка расчёта характеристик чертежа/структуры для HUD Ангара.
// Модули приходят с бэкенда world_manager в формате:
//   { base_stats: { mass_kg, power_draw, power_output, crew_required, ... }, ... }
// и/или { mass_kg, power_draw, ... } в корне.
// Здесь нормализуем оба варианта.

const num = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

// Достаёт числовое поле сначала из корня модуля, потом из base_stats.
const pick = (mod, key) => {
  if (!mod || typeof mod !== 'object') return 0;
  if (mod[key] !== undefined && mod[key] !== null) return num(mod[key]);
  const base = mod.base_stats;
  if (base && typeof base === 'object' && base[key] !== undefined && base[key] !== null) {
    return num(base[key]);
  }
  return 0;
};

const EMPTY = {
  mass: 0, cost: 0,
  powerDraw: 0, powerGen: 0, powerBalance: 0,
  crew: 0, cargo: 0, combat: 0, shield: 0,
};

export function calculateSchemeStats(scheme) {
  if (!scheme || typeof scheme !== 'object') return { ...EMPTY };

  const modules = Array.isArray(scheme.installed_modules)
    ? scheme.installed_modules
    : (Array.isArray(scheme.modules) ? scheme.modules : []);

  const acc = modules.reduce((a, mod) => {
    a.mass      += pick(mod, 'mass_kg') || pick(mod, 'mass');
    a.cost      += pick(mod, 'cost') || pick(mod, 'construction_cost');
    a.powerDraw += pick(mod, 'power_draw') || pick(mod, 'power_requirement');
    a.powerGen  += pick(mod, 'power_output');
    a.crew      += pick(mod, 'crew_required') || pick(mod, 'crew_capacity');
    a.cargo     += pick(mod, 'cargo_capacity');
    a.combat    += pick(mod, 'weapon_damage');
    a.shield    += pick(mod, 'shield_strength');
    return a;
  }, { ...EMPTY });

  // Стоимость модулей бэкенд не кладёт — берём оценочную стоимость объекта.
  if (acc.cost === 0) {
    acc.cost = num(scheme.current_value) || num(scheme.estimated_cost) || 0;
  }

  // Если по модулям энергетика нулевая, используем системные поля самого объекта.
  if (acc.powerGen === 0)  acc.powerGen  = num(scheme.power_output);
  if (acc.powerDraw === 0) acc.powerDraw = num(scheme.power_draw);

  // Экипаж: если модули не дали — берём системное поле.
  if (acc.crew === 0) acc.crew = num(scheme.crew_required) || num(scheme.crew_count);

  acc.powerBalance = acc.powerGen - acc.powerDraw;

  return acc;
}

export default { calculateSchemeStats };